module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"lt":{"title":"Prenumeruokite naujienlaiškį!","email":"El. Paštas","name":"Vardas arba įmonės pavadinimas","phone":"Telefono numeris","message":"Žinutė","send":"Prenumeruoti","success":"Dėkojame! Susisieksime."}}')
  delete Component.options._Ctor
}
